import { TemplateConfig } from '../types';

export const friendshipEnergyScanConfig: TemplateConfig = {
  id: 'friendship-energy-scan',
  name: '友情能量扫描牌阵',
  description: '分析人际以及友情方面的情况，看到你在人际关系中的总体能量与角色',
  cardCount: 7,
  
  fieldDefaults: {
    title: '友情能量扫描牌阵',
    customerQuestion: '**分析人际以及友情方面的情况，看到你在人际关系中的总体能量与角色。**',
    cardPlaceholders: [
      '请输入第 2 列第 1 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 2 列第 2 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 2 列第 3 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 3 列第 2 张牌'
    ],
    cardInfos: [
      '你在人际关系中的总体能量与角色',
      '谁是真正喜欢你、支持你的人(朋友特质)',
      '谁在表面亲近，实则心有疙瘩(表里不一)',
      '谁是明显不喜欢你或对你有敌意的人',
      '为什么会有人讨厌你?原因/你无意中引发的反感',
      '未来谁会越来越靠近你?值得你珍惜的人',
      '未来谁会渐行渐远?建议保持距离的人'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#1890ff',
    backgroundColor: '#e6f7ff',
    icon: '🤝'
  }
};
